import { useGoals } from 'features/goals';
import { useLocalizedLifeAreas } from 'features/life-areas';
import React from 'react';
import { CheckCircle } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import { Headers, TaskSection } from 'shared/components/ui/task-section';
import { useOpenPremiumDialog } from 'shared/contexts/premium-dialog';

import { useCompletedDateSections } from '../../hooks/use-completed-date-sections';
import * as Styled from './completed-tasks-list.style';

export const CompletedTasksList: React.FC = () => {
  const { sections } = useCompletedDateSections();
  const goals = useGoals();
  const lifeAreas = useLocalizedLifeAreas();
  const openPremiumDialog = useOpenPremiumDialog();

  return sections.length ? (
    <Styled.Container>
      {sections.map(({ id, items, endDate }) => (
        <TaskSection
          key={id}
          goals={goals}
          lifeAreas={lifeAreas}
          onPremium={openPremiumDialog}
          tasks={items}
          headerToDisplay={Headers.Date}
          date={endDate}
          displayDue={[]}
          completionDate={endDate}
          showRepeatingAsTodo
        />
      ))}
    </Styled.Container>
  ) : (
    <Styled.EmptyIconContainer>
      <Icon icon={CheckCircle} />
    </Styled.EmptyIconContainer>
  );
};
